exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".boxLight---2hoK0, .container---37Vwu {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.container---37Vwu {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  -webkit-box-shadow: 3px 3px 1px #e7e9ea;\n          box-shadow: 3px 3px 1px #e7e9ea;\n  min-width: 20%;\n  height: 36px;\n  border: 1px solid #e1e1e1;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background-color: #fff;\n  color: #4e5c67;\n  font-family: Poppins;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer; }\n\n.wrapper---fx-pn {\n  width: 100%;\n  outline: none; }\n\n.wrapper---fx-pn span {\n    width: 80%;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none; }\n\n.icon---3zFgy {\n  width: 20px;\n  height: 21px;\n  margin-right: 10px;\n  float: right; }\n", ""]);

// exports
exports.locals = {
	"boxLight": "boxLight---2hoK0",
	"container": "container---37Vwu",
	"wrapper": "wrapper---fx-pn",
	"icon": "icon---3zFgy"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/button/box.scss
// module id = 1091
// module chunks = 3